/**
 * Commenting other two props as this needs extra implimentation,
 * Once done that we will have to just uncoment  properties. And of course this comment too :)
 *
 * [Suggestion Needed] This Array can be moved to some other file, for better abstraction
 *
 */
const PII_PROPS = {
  SSN: 'SSN',
  DOB: 'DOB',
  LAST_FOUR_SSN: 'LAST_FOUR_SSN',
};

const DISABLED_PII_PROPERTIES = [PII_PROPS.SSN];

export default class PII {
  /**
   * This will use reference of parameter and remove ssn from array of object or from object
   * This function will remove all PII props from given array or object.
   * To remove any specific PII not all then this function can be used like
   *
   * PII.clean(arrClient, ['ssn']); This only remove ssn from given array
   * PII.clean(arrClient); This will remove all PII properties defined in DISABLED_PII_PROPERTIES.
   *
   * @param {Array | Object} mixClient
   * @param {Array?} arrPiiProps  (optional) PII properties to remove
   *
   * @returns {Array | Object} no need of return, as parameter is used as reference
   */
  static clean(mixClient, arrPiiProps = DISABLED_PII_PROPERTIES) {
    if (!mixClient) {
      return mixClient;
    }

    if (Array.isArray(mixClient)) {
      mixClient.forEach((objClient) => {
        PII.clean(objClient);
      });

      return mixClient;
    }

    const objClient = mixClient;

    arrPiiProps.forEach((piiProp) => {
      // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
      delete objClient[piiProp];
    });

    return mixClient;
  }

  static getProps() {
    return PII_PROPS;
  }

  /**
   * This converts array to comma seprated values
   * @param {Array} arrPiiProps
   *
   * @returns {String}
   */
  static toUrlString(arrPiiProps) {
    return arrPiiProps.join(',');
  }
}
